import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PLANAPI from '../../Api/planapi';
import { setMessage } from './message';
import EventBus from '../../utils/EventBus';

export const fetchPlan = createAsyncThunk(
  'plan/fetchPlan',
  async (params, thunkAPI) => {  
    try {
      const response = await PLANAPI.getPlan(params);
       
      return response.data; 
    }  catch (error) {
      const message = (error.response && error.response.data && error.response.data) || error.message || error.toString();
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }

  }  
);  

// Get Plan By Id
export const getPlanById = createAsyncThunk(
  'plan/getPlanById',
  async (id, thunkAPI) => {  
    try {
      const response = await PLANAPI.getPlanById(id); 
      return response.data; 
    }  catch (error) {
      const message = (error.response && error.response.data && error.response.data) || error.message || error.toString();
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }

  }  
);  

//CretePlan
export const createPlan = createAsyncThunk(
  'plan/createPlan',
  async (formData, thunkAPI) => {  
    try {
      const response = await PLANAPI.createPlan(formData); 
      const message=(response.message);
      thunkAPI.dispatch(setMessage(message));
      // console.log("res:",response.data)

      return response.data; 
    }  catch (error) {
      const message = (error.response && error.response.data && error.response.data) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      return thunkAPI.rejectWithValue(message);
    }

  }  
);

//Update Plan
export const updatePlan = createAsyncThunk(
  'plan/updatePlan',
  async ({id,formData}, thunkAPI) => {  
    try {
      const response = await PLANAPI.updatePlan(id,formData); 
      const message=(response.message);
      thunkAPI.dispatch(setMessage(message));
      return response.data; 
    }  catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }

  }  
);

//Delete Plan
export const deletePlan = createAsyncThunk(
  'plan/deletePlan',
  async (id, thunkAPI) => {  
    try {
      const response = await PLANAPI.deletePlan(id); 
      const message=(response.data.message);
      thunkAPI.dispatch(setMessage(message));
      return id; 
    }  catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }

  }  
);



const PlanSlice = createSlice({
  name: 'plan',
  initialState: {
    plans: [], 
    planDetails:"", 
    loading:false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlan.fulfilled, (state, action) => {
        state.plans = action.payload.data; 
        state.loading = false;
      })
      .addCase(fetchPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getPlanById.fulfilled, (state, action) => {
        state.planDetails = action.payload.data; 
        state.loading = false;
      })
      .addCase(getPlanById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(createPlan.fulfilled, (state, action) => {
        state.plans.push(action.payload.data)
        state.loading = false;
      })
      .addCase(createPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePlan.fulfilled, (state, action) => {
        const updatedPlan = action.payload.data; // Assuming the updated plan comes in `action.payload.data`
        
        console.log("Updated Plan:", updatedPlan);
      
        // Update the specific plan in the state
        state.plans = state.plans.map((plan) =>
          plan._id === updatedPlan._id 
            ? { ...plan, ...updatedPlan } // Spread to ensure all fields (including template) are updated
            : plan
        );
      
        state.loading = false; // Set loading to false after update
      })
      
      .addCase(updatePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deletePlan.fulfilled, (state, action) => {
         state.plans = state.plans.filter((plan) => plan._id !== action.payload )
         state.loading = false
       })
       .addCase(deletePlan.rejected, (state, action) => {
         state.loading = false
         state.error = action.payload
       }) 
  }  
});

const { reducer } = PlanSlice;
export default reducer;